( function () {
	/* global Bugsnag, angular */
	'use strict';

	function bugsnagNotifier ( logger ) {
		return function ( exception, cause ) {
			logger.error( exception, cause );
			Bugsnag.notifyException( exception, {
				'diagnostics' : {
					'cause' : cause
				}
			} );
		};
	}

	angular
		.module( 'exceptionOverride', [] )
		.factory( '$exceptionHandler', bugsnagNotifier );
} )( );
